import { render, staticRenderFns } from "./tactics.vue?vue&type=template&id=e958468c&scoped=true&"
import script from "./tactics.vue?vue&type=script&lang=js&"
export * from "./tactics.vue?vue&type=script&lang=js&"
import style0 from "./tactics.vue?vue&type=style&index=0&id=e958468c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e958468c",
  null
  
)

export default component.exports